import {store} from '../component/Shop';
import {axios} from '../index';

export const receiveShoppingCartUpdate = (cart) => ({type: 'RECEIVE_CART_UPDATE', cart});
export const receiveMesseCartUpdate = (messecart) => ({type: 'RECEIVE_MESSECART_UPDATE', messecart});
export const receiveMetaUpdate = (meta) => ({type: 'RECEIVE_META_UPDATE', meta});
export const receiveMobileUpdate = (mobile) => ({type: 'RECEIVE_MOBILE_UPDATE', mobile});
export const receiveMobileMediumUpdate = (mobileMedium) => ({type: 'RECEIVE_MOBILEMEDIUM_UPDATE', mobileMedium});
export const receiveMobileBigUpdate = (mobileBig) => ({type: 'RECEIVE_MOBILEBIG_UPDATE', mobileBig});

export const mobilePossible = (possible) => ({type: 'MOBILE_POSSIBLE', possible});

export const receiveLoadingUpdate = (loading) => ({type: 'RECEIVE_LOADING_UPDATE', loading});

export const displayToastUpdate = (display) => ({type: 'RECIEVE_DISPLAY_TOAST', display});

export const setMSG = (msg) =>
  ({type: 'RECIEVE_MSG', msg});

export const setUpdateMSG = (boo) =>
  ({type: 'RECIEVE_UPDATE_MSG', boo});
export const setUpdateAmount = (boo) =>
  ({type: 'RECIEVE_UPDATE_AMOUNT', boo});

const receiveOrdersatzData = (data, menge, type) => ({
  type: 'RECEIVE_ORDERSATZ_DATA',
  data,
  menge,
  produkttyp: type
});
export const updateMesseCart = (messe, type, id, mengen) => {
  return async (dispatch) => {
    try {
      let mengen2 = null;
      if(mengen){
        mengen2 = JSON.stringify(mengen);
      }
      const result = await axios.post(`/changeMesseCart/${messe}/${type}/${id}/`, {
        mengen:mengen2});
      dispatch(receiveMesseCartUpdate(result.data.messecartdata));
    } catch (e) {
      console.log(e);
    }
  };
};
export const updateShoppingCart = (type, id, menge, override = true, pos, mengen, url, gvl) => {

  menge = menge || 0;
  if(type==="m"){
    return async (dispatch) => {
      try {
        let menge = 1;
        if(!mengen){
          menge= 0;
        }
        url = url || '';
        const result = await axios.post(url+`/changeCart/m/${id}/${menge}/`, {override: override, pos:pos,
          mengen:JSON.stringify(mengen), menge: menge, gvl: gvl});

        dispatch(receiveShoppingCartUpdate(result.data.cartdata));
        // dispatch(receiveOrdersatzData(result.data.ordersatzdata, menge, type));
      } catch (e) {
        // console.log(e);
      }
    };
  }else{

    return async (dispatch) => {
      try {
        const result = await axios.post(url+`/changeCart/${type}/${id}/${menge}/`, {override: override, gvl: gvl});
        dispatch(receiveShoppingCartUpdate(result.data.cartdata));
        dispatch(receiveOrdersatzData(result.data.ordersatzdata, menge, type));
      } catch (e) {
        // console.log(e);
      }
    };
  }

};

export const clearShoppingCart = (url) => {
  return async (dispatch) => {
    try {
      const result = await axios.post(url+'/clearCart/', {});
      dispatch(receiveShoppingCartUpdate(result.data.cartdata));
    } catch (e) {
      // console.log(e);
    }
  };
};

export const clearShoppingMesseCart = (messe) => {
  return async (dispatch) => {
    try {
      const result = await axios.post('/clearMesseCart/'+messe+'/', {});
      dispatch(receiveMesseCartUpdate(result.data.messecartdata));
    } catch (e) {
      // console.log(e);
    }
  };
};

export const updateShoppingCartClient = (result) => {
  return (dispatch) => {
    dispatch(receiveShoppingCartUpdate(result));
  };
};
export const updateMesseCartClient = (result) => {
  return (dispatch) => {
    dispatch(receiveMesseCartUpdate(result));
  };
};
export const toggle_mobile_menu = () => {
  return (dispatch) => {
    dispatch({type: 'TOGGLE'});
  };
};

export const show_mobile_menu = () => {
  return (dispatch) => {
    dispatch({type: 'SHOW'});
  };
};

export const hide_mobile_menu = () => {
  return (dispatch) => {
    dispatch({type: 'HIDE'});
  };
};

//const mql = window.matchMedia('screen and (max-width: 850px)');

function updateMobile (e) {
  store.dispatch(receiveMobileUpdate(!!e.matches));
}

//mql.addListener(updateMobile);
